import { formatDate } from "../../utils/functions"
import classes from "./ProfileDetails.module.css"

const ProfileDetails = ({labData = []}) => {
    return(
        <div className={classes.detailsContainer}>
        <h1>{labData.labName}</h1>
        <div className={classes.licenceNumber}>{labData.hpczLicense}</div>
        <div className={classes.labDetailsContainer}>
          <div
            className={`d-flex align-items-center justify-content-between ${classes.topSummary}`}
          >
            <div>
              <div className={classes.label}>Date & time</div>
              <div className={classes.value}>
                 {labData.createdAt ? formatDate(labData.createdAt) : ""}
              </div>
            </div>
            <div>
              <div className={classes.label}>Tier Level</div>
              <div className={classes.value}>{labData.tierLevel}</div>
            </div>
            <div>
              <div className={classes.label}>Type</div>
              <div className={classes.value}>{labData.type}</div>
            </div>
            <div>
              <div className={classes.label}>Affiliation</div>
              <div className={classes.value}>{labData.affiliation}</div>
            </div>
          </div>

          <div className={classes.section}>
            <h5>Facility details</h5>
            <div className={classes.detailGrid}>
              <div className={classes.label}>Province</div>
              <div className={classes.value}>{labData.province}</div>

              <div className={classes.label}>City/Town</div>
              <div className={classes.value}>{labData.city}</div>

              <div className={classes.label}>Physical address</div>
              <div className={classes.value}>{labData.physicalAddress}</div>

              <div className={classes.label}>Facility phone</div>
              <div className={classes.value}>{labData.telephone}</div>

              <div className={classes.label}>Facility fax</div>
              <div className={classes.value}>{labData.fax}</div>

              <div className={classes.label}>Facility email address</div>
              <div className={classes.value}>{labData.email}</div>
            </div>
          </div>

          <div className={classes.section}>
            <h5>Personnel details</h5>
            <div className={classes.detailGrid}>
              <div className={classes.label}>Name of facility Incharge</div>
              <div className={classes.value}>{labData.personnelName}</div>

              <div className={classes.label}>Qualification</div>
              <div className={classes.value}>{labData.qualification}</div>

              <div className={classes.label}>Personnel phone</div>
              <div className={classes.value}>{labData.personnelPhone}</div>

              <div className={classes.label}>Personnel email</div>
              <div className={classes.value}>{labData.personnelEmail}</div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ProfileDetails